import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { ROLE_LABELS } from "@/lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const UserDialog = ({ user, onClose, onSaved }) => {
  const isNew = user && !user.id;
  const [v, setV] = useState({});
  const [error, setError] = useState("");
  useEffect(() => {
    if (user) setV({ name: user.name || "", email: user.email || "", password: "", role: user.role || "vendedor", active: user.active ?? true });
    setError("");
  }, [user]);
  const set = (k) => (val) => setV((s) => ({ ...s, [k]: val }));
  const valid = v.name?.trim() && v.email?.trim() && (isNew ? v.password?.length >= 6 : !v.password || v.password.length >= 6);

  const save = async () => {
    setError("");
    const body = { ...v };
    if (!body.password) delete body.password;
    try {
      if (isNew) await api.post("/admin/users", body);
      else await api.patch(`/admin/users/${user.id}`, body);
      toast.success(isNew ? "Usuario creado" : "Usuario actualizado");
      onSaved();
      onClose();
    } catch (e) { setError(errorMessage(e)); }
  };

  return (
    <Dialog open={!!user} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-2xl sm:max-w-md" data-testid="user-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl font-extrabold">{isNew ? "Nuevo usuario" : "Editar usuario"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          {[["name", "Nombre", "text"], ["email", "Correo", "email"], ["password", isNew ? "Contraseña (mín. 6)" : "Nueva contraseña (opcional)", "password"]].map(([k, l, t]) => (
            <div key={k}>
              <Label className="text-xs font-semibold text-slate-600">{l}</Label>
              <Input type={t} value={v[k] || ""} onChange={(e) => set(k)(e.target.value)} className="mt-1.5 h-10 rounded-xl" data-testid={`user-input-${k}`} />
            </div>
          ))}
          <div>
            <Label className="text-xs font-semibold text-slate-600">Rol</Label>
            <Select value={v.role} onValueChange={set("role")}>
              <SelectTrigger className="mt-1.5 h-10 rounded-xl" data-testid="user-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(ROLE_LABELS).map(([k, l]) => <SelectItem key={k} value={k} data-testid={`role-option-${k}`}>{l}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <label className="flex items-center justify-between rounded-xl bg-[#F5F7FA] p-3 text-sm font-medium">
            Activo <Switch checked={v.active} onCheckedChange={set("active")} data-testid="user-active-switch" />
          </label>
          {error && <p className="text-sm text-rose-600" data-testid="user-dialog-error">{error}</p>}
          <Button onClick={save} disabled={!valid} className="w-full rounded-xl bg-[#1E6FD9]" data-testid="user-save-button">Guardar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
